import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  BULK_DELETE_BUSINESS_ABORT_PROCESS,
  BULK_DELETE_BUSINESS_CONFIRM_PROCESS_RESPOND,
  BULK_DELETE_BUSINESS_INITIALIZE_PROCESS_STATE,
  BULK_DELETE_BUSINESS_LOG_SET_DATA,
  BULK_DELETE_BUSINESS_LOG_SET_ERRORS,
  BULK_DELETE_BUSINESS_LOG_SET_IS_LOADING,
  BULK_DELETE_BUSINESS_LOG_SET_SHOWN,
  BULK_DELETE_BUSINESS_PREPEND_BUSINESS_ERROR,
  BULK_DELETE_BUSINESS_SET_CURRENT_BUSINESS_ID,
  BULK_DELETE_BUSINESS_SET_GLOBAL_ERROR,
  BULK_DELETE_BUSINESS_SET_IS_PROCESSING,
  BULK_DELETE_BUSINESS_SET_PROCESS_STATUS,
  BULK_DELETE_BUSINESS_SET_PROCESSED_COUNT,
  BULK_DELETE_BUSINESS_SHOW_CONFIRM_PROCESS_MODAL,
} from 'state/actionTypes';
import ProcessStatus from '../../constants/bulkAction/processStatus';

const isProcessing = createReducer(false, {
  [BULK_DELETE_BUSINESS_SET_IS_PROCESSING]: (state, { payload }) =>
    payload.isProcessing,
});

const processInitialState = {
  processed: 0,
  businessIds: [],
  errors: [],
  currentBusinessId: null,
  status: null,
  cancelRequested: false,
  globalError: null,
};

const process = createReducer(processInitialState, {
  [BULK_DELETE_BUSINESS_INITIALIZE_PROCESS_STATE]: (
    state,
    { payload: { businessIds } }
  ) => ({
    processed: 0,
    businessIds,
    errors: [],
    currentBusinessId: null,
    status: ProcessStatus.InProgress,
    cancelRequested: false,
    globalError: null,
  }),
  [BULK_DELETE_BUSINESS_SET_PROCESSED_COUNT]: (state, { payload }) => ({
    ...state,
    processed: payload.processed,
  }),
  [BULK_DELETE_BUSINESS_SET_CURRENT_BUSINESS_ID]: (state, { payload }) => ({
    ...state,
    currentBusinessId: payload.businessId,
  }),
  [BULK_DELETE_BUSINESS_SET_PROCESS_STATUS]: (state, { payload }) => ({
    ...state,
    status: payload.status,
  }),
  [BULK_DELETE_BUSINESS_PREPEND_BUSINESS_ERROR]: (state, { payload }) => ({
    ...state,
    errors: [{ ...payload }, ...state.errors],
  }),
  [BULK_DELETE_BUSINESS_ABORT_PROCESS]: state => ({
    ...state,
    cancelRequested: true,
  }),
  [BULK_DELETE_BUSINESS_SET_GLOBAL_ERROR]: (state, { payload }) => ({
    ...state,
    globalError: payload.error,
  }),
});

const confirmModalShown = createReducer(false, {
  [BULK_DELETE_BUSINESS_SHOW_CONFIRM_PROCESS_MODAL]: () => true,
  [BULK_DELETE_BUSINESS_CONFIRM_PROCESS_RESPOND]: () => false,
});

const logModalInitialState = {
  shown: false,
  isLoading: false,
  data: [],
  paging: {
    page: 1,
    size: 20,
    total: 0,
  },
  errors: [],
};

const log = createReducer(logModalInitialState, {
  [BULK_DELETE_BUSINESS_LOG_SET_SHOWN]: (draft, { payload }) => {
    draft.shown = payload.shown;
  },
  [BULK_DELETE_BUSINESS_LOG_SET_DATA]: (draft, { payload }) => {
    draft.data = payload.data;
    draft.paging = payload.paging;
  },
  [BULK_DELETE_BUSINESS_LOG_SET_IS_LOADING]: (draft, { payload }) => {
    draft.isLoading = payload.isLoading;
  },
  [BULK_DELETE_BUSINESS_LOG_SET_ERRORS]: (draft, { payload }) => {
    draft.errors = payload.errors;
  },
});

export default combineReducers({
  isProcessing,
  process,
  confirmModalShown,
  log,
});
